<script lang="ts">
  import { Router, navigate } from 'sly-svelte-location-router'
  import type { Routes } from 'sly-svelte-location-router'
  import { authState, authInitialized } from '@lib/store/auth'
  import {derived, get} from 'svelte/store'
  import ToastContainer from '@components/ToastContainer.svelte'
  import { modalStore } from '@lib/store/modals'
  import { hotkey } from '@lib/directives/hotkey'
  import { onMount } from 'svelte'

  const isAuthenticated = derived(authState, state => state.isAuthenticated)
  const isLoading = derived(authState, state => state.isLoading)

  const openSearchDialog = () => {
    modalStore.set({
      key: 'search-dialog'
    })
  }

  onMount(async () => {
    await authInitialized

    const params = new URLSearchParams(window.location.search)
    const client = params.get('client')
    const code = params.get('code')
    const currentPath = window.location.pathname

    if (client === 'sdm' && code && $authState.isAuthenticated && currentPath !== '/auth/cli') {
      navigate(`/auth/cli?client=sdm&code=${code}`, { replace: true })
    }
  })

  $effect(() => {
    const state = $authState
    const currentPath = window.location.pathname

    if (!state.isLoading && !state.isAuthenticated) {
      if (currentPath.startsWith('/main')) {
        navigate('/login', {
          state: { message: 'Please login to continue' },
          replace: true
        })
      }
    }
  })

  const routes: Routes = {
    '/': '/main',
    '/main': {
      name: 'app',
      component: () => import('@pages/MainPage.svelte'),
      guard: async () => {
        await authInitialized
        const state = get(authState)
        if (!state.isAuthenticated) {
          return {
            path: '/login',
            state: { message: 'Please login to continue' },
            replace: true
          }
        }
      }
    },
    '/login': {
      name: 'login',
      component: () => import('@pages/LoginPage.svelte')
    },
    '/auth/cli': {
      name: 'cli-auth',
      component: () => import('@pages/CLIAuthPage.svelte'),
      guard: async () => {
        await authInitialized
        const state = get(authState)

        const params = new URLSearchParams(window.location.search)
        const client = params.get('client')
        const code = params.get('code')

        if (client !== 'sdm' || !code) {
          if (state.isAuthenticated) {
            return {
              path: '/main',
              replace: true
            }
          } else {
            return {
              path: '/login',
              replace: true
            }
          }
        }

        if (!state.isAuthenticated) {
          return {
            path: `/login?client=sdm&code=${code}`,
            state: { message: 'Please login to continue' },
            replace: true
          }
        }
      }
    },
  }
</script>

<ToastContainer />
<button class="hidden" onclick={openSearchDialog} use:hotkey={['ctrl+k', 'cmd+k']}></button>

<Router {routes} fallback={() => import('@pages/ErrorPage.svelte')}>
  <div class="flex items-center justify-center min-h-screen">
    <span class="loading loading-spinner loading-lg"></span>
  </div>
</Router>